import { BrandFamily, Domains, FlowType } from "../types/types";
import { LegalArea } from "./getInitialisationConfig";
import resolveExperimentFlow from "@/core/utils/resolveExperimentFlow";

const getFlowTypeFromLegalArea = (
  legalArea: LegalArea,
  brandFamily: BrandFamily,
  domain: Domains
): FlowType => {
  if (legalArea === LegalArea.MIE) return FlowType.MIE;

  if (legalArea === LegalArea.ARB) return FlowType.ARB;

  return resolveExperimentFlow(brandFamily, domain);
};

export default getFlowTypeFromLegalArea;
